import { Capacitor } from '@capacitor/core';

/**
 * Thin wrapper around @capacitor/core so the rest of the app can branch on
 * native-vs-web without importing the plugin directly everywhere.
 *
 * On the plain web build (desktop browser, PWA) `isNative()` returns false and
 * the rest of the helpers return safe defaults — this keeps the `npm run serve`
 * developer workflow unchanged.
 */
const platform = Capacitor.getPlatform(); // 'ios' | 'android' | 'web'

export const isNative = () => Capacitor.isNativePlatform();

export const isIOS = () => platform === 'ios';

export const isAndroid = () => platform === 'android';

export const isWeb = () => platform === 'web';

export const nativePlatform = () => (isNative() ? platform : null);

export default {
    isNative,
    isIOS,
    isAndroid,
    isWeb,
    nativePlatform,
    platform
};
